import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import NavigationBar from "./layout/NavigationBar";
import Footer from "../src/layout/Footer.js";
import AboutUsPage from "./pages/AboutUsPage";
import HowItWorks from "./pages/HowItWorks";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage.js";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage.js";
import ContactUsPage from "./pages/ContactUsPage.js";

function App() {
  return (
    <div>
      <NavigationBar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-Condition" element={<TermsAndConditionsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
